module.exports = __webpack_public_path__ + "img/support.3438a588.svg";